<script>
  import { favorite } from "../../models/favorite.js";
  import { userRented } from "../../models/userRented.js";
  import ProductPreview from "../../components/ProductPreview.svelte";
  import { subscription } from "../../models/subscription.js";
  import RentalQuota from "../../components/RentalQuota.svelte";
  import RentalQuotaSubscription from "../../components/RentalQuotaSubscription.svelte";
</script>

{#await $favorite}
  <p>Loading...</p>
{:then}
  <div class="favorites-header">
    <h2>Favorites</h2>
    {#if $favorite.products.length > 0}
      <span class="favorites-count"
        >{$favorite.products.length}
        {$favorite.products.length === 1 ? "puzzle" : "puzzles"}</span
      >
    {/if}
  </div>

  {#await $subscription then}
    <div class="quota-section">
      <RentalQuota />
      <RentalQuotaSubscription
        subscription={$subscription}
        clearError={subscription.clearError}
      />
    </div>
  {/await}

  <div class="fave-products">
    {#each $favorite.products as product}
      <ProductPreview
        {product}
        subDetails={$subscription}
        userRentedPrev={$userRented[product.sku]}
      />
    {/each}
    {#if $favorite.products.length === 0}
      <div class="empty-state">
        <p>You haven't favorited any puzzles yet.</p>
        <a href="/rent" class="btn">Browse Puzzles</a>
      </div>
    {/if}
  </div>
{/await}

<style type="text/less">
  .favorites-header {
    display: flex;
    align-items: baseline;
    gap: var(--spacing-sm);
    margin-bottom: var(--spacing);
  }

  .favorites-count {
    font-size: var(--font-size-sm);
    color: var(--col-gray-50);
  }

  .quota-section {
    margin-bottom: var(--spacing);
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
  }

  .fave-products {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--spacing-sm);
  }

  .empty-state {
    grid-column: 2;
    text-align: center;
    padding: var(--spacing-lg) var(--spacing);
    color: var(--col-gray-50);

    p {
      margin-bottom: var(--spacing-sm);
    }
  }

  @media (max-width: 1140px) {
    .fave-products {
      grid-template-columns: repeat(2, 1fr);
    }

    .empty-state {
      grid-column: 1;
    }
  }

  @media (max-width: 500px) {
    .fave-products {
      grid-template-columns: 1fr;
    }
  }
</style>
